import ReactApexChart from 'react-apexcharts';
import React, { useState, useMemo } from 'react';

const PendingTransaction = ({ series = [{ data: [] }] }) => {
      // const [series, setSeries] = useState([]);

  //    const fetchData = async () => {
  //    const fetchData = await axios.get(`${process.env.REACT_APP_API_URL}/api/Dashboard/DashboardOverviewPendingTrans?Month=${filter?.month}&Year=${filter?.year}`, {
  //           headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${localStorage.getItem("user_token")}`,
  //           },

  //       })

  //       // Process and update state
  //       const data = fetchData?.data?.response[0];
  //       const processedData = [
  //           parseInt(data.supervisorPending, 10),
  //           parseInt(data.ipPending, 10),
  //           parseInt(data.loamApproverPending, 10),
  //           parseInt(data.reviewerPending, 10),
  //           parseInt(data.deptCoPending, 10),
  //           parseInt(data.queriesPending, 10),
  //           parseInt(data.taxPending, 10),
  //           parseInt(data.irPending, 10),
  //       ];

  //       setSeries([{ name: 'Pending', data: processedData }]);
  // };
    // useEffect(async () => {
    //     // Simulate fetching data - replace this with your actual fetch call
    // if(fetchedData){
    //      fetchData()
    // }
    // }, [fetchedData]);
  const legendItems = [
    { label: 'AP Supervisor', color: '#60B564', key: 'apSupervisor' },
    { label: 'IP', color: '#22C3D7', key: 'ip' },
    { label: 'LOAM Approver', color: '#FFA320', key: 'loamApprover' },
    { label: 'Reviewer', color: '#D97757', key: 'reviewer' },
    { label: 'Department Coordinator', color: '#EE504D', key: 'deptCoordinator' },
    { label: 'Queries', color: '#A569BD', key: 'queries' },
    { label: 'Tax', color: '#5DADE2', key: 'tax' },
    { label: 'IR', color: '#F4D03F', key: 'ir' },
  ];

  const keys = [
    'apSupervisor',
    'ip',
    'loamApprover',
    'reviewer',
    'deptCoordinator',
    'queries',
    'tax',
    'ir'
  ];

  const [visibleLegends, setVisibleLegends] = useState(
    legendItems.map(item => item.key)
  );

  // replace the donutSeries state + effect with a memoized value
  const donutSeries = useMemo(() => {
    const updatedSeries = legendItems.map(item => {
      const index = keys.indexOf(item.key);
      return index >= 0 && series[0]?.data[index] != null
        ? Number(series[0].data[index])
        : 0;
    });

    // Apply filtering based on visible legends
    return legendItems
      .filter(item => visibleLegends.includes(item.key))
      .map(item => updatedSeries[keys.indexOf(item.key)]);
  }, [series, visibleLegends]);

  const toggleLegend = (key) => {
    setVisibleLegends(prev =>
      prev.includes(key)
        ? prev.filter(k => k !== key)
        : [...prev, key]
    );
  };

  // ⭐ FIX #2 → Use donutSeries directly so values show immediately
  const donutOptions = {
    labels: legendItems
      .filter(item => visibleLegends.includes(item.key))
      .map(item => item.label),

    colors: legendItems
      .filter(item => visibleLegends.includes(item.key))
      .map(item => item.color),

    legend: { show: false },

    dataLabels: {
      enabled: true,
      // use the chart's internal series so formatter has the exact rendered value
      formatter: (val, opts) => {
        const v = opts?.w?.globals?.series?.[opts.seriesIndex];
        return v != null ? v : 0;
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#fff']
      }
    },

    plotOptions: {
      pie: {
        dataLabels: { offset: 0 }
      }
    }
  };

  return (
    <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap' }}>
      
      {/* LEFT BAR CHART — unchanged */}
      <div style={{ flex: 2, minWidth: '400px' }}>
        <ReactApexChart
          options={{
            chart: { type: 'bar', height: 350, toolbar: { show: false } },
            plotOptions: { bar: { horizontal: true, barHeight: '50%' } },
            dataLabels: { enabled: false },
            xaxis: {
              categories: keys.map(
                k => legendItems.find(item => item.key === k).label
              ),
            },
          }}
          series={series}
          type="bar"
          height={350}
        />
      </div>

      {/* RIGHT DONUT SECTION */}
      <div style={{ flex: 1, minWidth: '250px', textAlign: 'center' }}>
        <h3>Overall</h3>

        {/* Legend items */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '6px',
            marginBottom: '10px',
          }}
        >
          {legendItems.map(item => {
            const active = visibleLegends.includes(item.key);
            return (
              <div
                key={item.key}
                onClick={() => toggleLegend(item.key)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '3px',
                  cursor: 'pointer',
                  opacity: active ? 1 : 0.4,
                  transition: 'all 0.2s ease',
                  fontSize: '12px',
                }}
              >
                <span
                  style={{
                    width: '15px',
                    height: '8px',
                    backgroundColor: item.color,
                    display: 'inline-block',
                    borderRadius: '2px',
                  }}
                />
                <span>{item.label}</span>
              </div>
            );
          })}
        </div>

        {/* DONUT */}
        <ReactApexChart
          options={donutOptions}
          series={donutSeries}
          type="donut"
          width="100%"
          height={250}
        />
      </div>
    </div>
  );
};

export default PendingTransaction;
